import { Card, CardContent, CardHeader, Grid, Button, Alert, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { apiConstants, post } from "../../common/constants";
import ProzoDataGrid from "../../common/ProzoDataGrid";
import { formatDate } from "../../helpers/UtilityHelper";
import PageTitle from "../../components/PageTitle";
import Loader from "../../common/Loader";
import { FormProvider, RHFSearchableSelectField, RHFTextField } from "../../common/hook-form";
import { useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";
import { useGetAllActiveMerchantsIdAndNameCachedQuery } from "../../redux/commonApiCalls";

function UserLevelPiiAccess() {
    const [user, setUser] = useState([])
    const [page, setPage] = useState(0);
    const [reload, setReload] = useState(0)
    const [sizePerPage, setSizePerPage] = useState(20)
    const [isLoading, setIsLoading] = useState(false)
    const [filter, setFilter] = useState([])
    const [isSubmitting, setIsSubmitting] = useState(false)
    const { data: merchants = [] } = useGetAllActiveMerchantsIdAndNameCachedQuery()

    const methods = useForm({
        defaultValues: {
            merchant: "",
            email: "",
        }
    });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        setIsLoading(true)
        const andfilter = [
            {
                "field": "piiAccess",
                "operator": "eq",
                "value": true
            },
            ...filter
        ]
        const request = {
            "collection": "users",
            "andfilter": andfilter,
            "offset": page * sizePerPage,
            "limit": sizePerPage,
            "sort": {
                "field": "lastModifiedDate",
                "direction": "DESC"
            }
        }
        post(apiConstants.GET_USER, request).then((res) => {
            setUser(res?.data)
        }).catch((err) => console.log(err)).finally(() => setIsLoading(false))
    }, [reload, page, sizePerPage, filter])

    const onSubmit = (data) => {
        setIsSubmitting(true);
        const newFilters = [];
        if (data?.merchant) {
            newFilters.push({
                "field": "parentMerchant",
                "operator": "eq",
                "value": data?.merchant
            });
        }
        if (data?.email?.trim()) {
            newFilters.push({
                "field": "email",
                "operator": "like",
                "value": data?.email?.trim() + ".*"
            });
        }
        setFilter(newFilters);
        setIsSubmitting(false);
    };

    const columns = [
        {
            field: 'fullName',
            headerAlign: "left",
            hideSortIcons: true,
            align: 'left',
            headerName: 'User Name',
            width: 130,
        },
        {
            field: 'email',
            headerAlign: "left",
            hideSortIcons: true,
            align: 'left',
            headerName: 'Email Id',
            width: 240,
        },
        {
            field: 'roles',
            headerAlign: "left",
            hideSortIcons: true,
            align: 'left',
            headerName: 'Roles',
            width: 160,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Grid container spacing={1}>
                        {row?.roles?.map((role, index) => (
                            <Grid item xs={12} key={index}>
                                {role}
                            </Grid>
                        ))}
                    </Grid>
                );
            },
        },
        {
            field: 'createdDate',
            headerAlign: "left",
            hideSortIcons: true,
            align: 'left',
            headerName: 'Created Date',
            width: 160,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>{formatDate(row?.createdDate)} </>
                )
            },
        },
        // {
        //     field: 'lastModifiedDate',
        //     headerAlign: "left",
        //     hideSortIcons: true,
        //     align: 'left',
        //     headerName: 'Modified Date',
        //     width: 160,
        //     renderCell: (params) => {
        //         const { row } = params;
        //         return (
        //             <>{formatDate(row?.lastModifiedDate)} </>
        //         )
        //     },
        // },
        {
            field: 'lastLogin',
            headerAlign: "left",
            hideSortIcons: true,
            align: 'left',
            headerName: 'Last Login',
            width: 160,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>{formatDate(row?.logins?.lastLogin)} </>
                )
            },
        },
        {
            field: 'createdByUser',
            headerAlign: "left",
            hideSortIcons: true,
            align: 'left',
            headerName: 'Created By',
            width: 160,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        {row?.createdByUser && row?.createdByUser.trim() !== "" 
                            ? row.createdByUser 
                            : <>
                                <span style={{ color: "#888" }}>Self Registration via Proship Panel</span>
                              </>
                        }
                    </>
                )
            },
        },
    ]

    return (
        <>
            {isLoading && <Loader />}
            <PageTitle>User Level PII Access</PageTitle>
            <Alert severity="info" sx={{ mb: 2 }}>
                <Typography variant="body2">
                    Below users are the users where PII data is available in all reports and UI on both admin panel (if admin panel access is given) and merchant panel (if merchant panel access is given).
                </Typography>
            </Alert>
            <Card sx={{ pb: 2 }}>
                <CardContent>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={3}>
                                <RHFTextField name='email' label='Email Id' />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <RHFSearchableSelectField 
                                    name="merchant" 
                                    label="Merchant" 
                                    width='100%' 
                                    color="secondary" 
                                    options={merchants?.map((val) => ({ label: val.name, value: val.id }))}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sx={{ display: 'flex', alignItems: 'center' }}>
                                <LoadingButton
                                    loading={isSubmitting}
                                    variant="contained"
                                    size="small"
                                    type="submit"
                                >Search</LoadingButton>
                                <Button 
                                    variant="contained" 
                                    color="error" 
                                    size="small" 
                                    sx={{ ml: 1 }}
                                    onClick={() => {
                                        reset()
                                        setReload(reload + 1)
                                        setFilter([])
                                        setUser([])
                                    }}
                                >Reset</Button>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </CardContent>
            </Card>
            <Card sx={{ mt: 2 }}>
                <CardContent>
                    <ProzoDataGrid
                        columns={columns}
                        autoHeight={true}
                        rows={user?.data ? user?.data : []}
                        sizePerPage={sizePerPage}
                        setSizePerPage={setSizePerPage}
                        setPage={setPage}
                        page={page}
                        pagination={true}
                        hideFooterPagination={false}
                        rowHeight={120}
                        rowCount={user?.count || 0}
                        getRowId={(row) => row?.id} />
                </CardContent>
            </Card>
        </>
    )
}

export default UserLevelPiiAccess;
